export const INBOX_DRAG_TYPE = "INBOX_DRAG_TYPE" as const;
export const INBOX_LOCALSTORAGE_KEY = "$INBOX_DATA" as const;
